import _ from "underscore";
import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import url from "web/script/utils/url";
import userProfiler from "web/script/modules/userprofiler";
import browser from "web/script/utils/browser";
import globals from "web/script/modules/globals";
import environment from "web/script/modules/environment";
import store from "web/redux/store";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";

const SHOW_PROMO_CODE_ENV_KEY = "showPromoCode";

export default baustein.register("lead-link", {
    defaultOptions: {
        eventCategory: null,
        eventAction: null,
        eventLabel: null,
        productHref: null,
        isSavedForLater: false,
        affiliatePromoUrl: null,
        triggersReactEmailCapture: null,
        useNewTabLogic: false,
    },

    setupEvents(add) {
        add("click", this.onClick);
    },

    init() {
        this.updateUrl = this.updateUrl.bind(this);
    },

    onInsert() {
        analytics.on("pageViewIdChanged", this.updateUrl);
        this.updateUrl();
    },

    onRemove() {
        analytics.off("pageViewIdChanged", this.updateUrl);
    },

    updateUrl() {
        var parsed = url.parse(this.el.href);

        parsed.searchParams.set("pageViewId", analytics.getPageViewId());

        ["reason", "type", "fromUrl"].forEach(
            function(key) {
                if (this.options[key]) {
                    parsed.searchParams.set(key, this.options[key]);
                }
            }.bind(this)
        );

        this.el.href = url.unparse(parsed);
    },

    onClick(event) {
        let pendingRequests = [];
        // sometimes we need to track the link as well as being a lead
        const isMobile = browser.getViewport() === browser.VIEWPORTS.MOBILE;
        const { href, target } = this.el;
        const { eventCategory, eventAction, eventLabel, useNewTabLogic } = this.options;
        const showPromoCode =
            this.options.affiliatePromoUrl && environment.get(SHOW_PROMO_CODE_ENV_KEY);

        // Save the clicked lead in the user localstorage profile only if a product id has
        // been provided
        if (this.options.productId) {
            userProfiler.saveClickedLead(this.options.productId, this.options.reason);
        }

        if (this.options.isSavedForLater) {
            pendingRequests.push(
                analytics.event("affiliate", "lead", "save_for_later_buy_on_store")
            );
        }

        // only track if we have all the information we need
        if (_.isString(eventCategory) && _.isString(eventAction) && href) {
            pendingRequests.push(analytics.event(eventCategory, eventAction, eventLabel));
        }

        // Open new tab with promo code url if one has been supplied
        if (showPromoCode) {
            globals.window.open(this.options.affiliatePromoUrl, "_blank");
        }

        // Open new tab, remove paid tracking params and add lof_disable_overlay
        var newTab;
        var scrollLocation = globals.window.scrollY;
        if (useNewTabLogic && !isMobile) {
            var parsedUrl = url.parse(globals.window.location.href);
            var queryParams = parsedUrl.searchParams;
            for (let key of queryParams.keys()) {
                // eslint-disable-next-line max-depth
                if (key.startsWith("atc_") || key.startsWith("utm_")) {
                    queryParams.delete(key);
                }
            }
            queryParams.set("lof_disable_overlay", true);
            newTab = globals.window.open(url.unparse(parsedUrl), "_blank");
            pendingRequests.push(
                new Promise(function(resolve) {
                    newTab.onload = resolve;
                })
            );
        }

        // If necessary, open track link in current tab once analytics have resolved
        event.preventDefault();
        if (showPromoCode || target !== "_blank" || useNewTabLogic) {
            Promise.all(pendingRequests).then(() => {
                if (newTab) {
                    newTab.scrollTo(0, scrollLocation);
                }
                globals.window.location = href;
            });
        } else {
            globals.window.open(href, "_blank");
            this.emit("show-bis-overlay");
            if (
                !userProfiler.isLoggedIn() &&
                this.options.triggersReactEmailCapture &&
                environment.get("boomLeadSignupPrompt")
            ) {
                store.dispatch(
                    openCustomerCaptureOverlay({
                        productId: this.options.productId.toString(),
                        captureType: "signup_lead_save",
                    })
                );
            }
        }
    },
});
